/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Plan_ComparisonInputs */

const en_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Comparison`)
};

const de_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planvergleich`)
};

const fr_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparaison des plans`)
};

const es_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparación de planes`)
};

const it_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto piani`)
};

const nl_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Vergelijking`)
};

const pl_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównanie planów`)
};

const fi_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suunnitelma vertailu`)
};

const da_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plansammenligning`)
};

const sv_settings_plan_comparison = /** @type {(inputs: Settings_Plan_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Jämförelse`)
};

/**
* | output |
* | --- |
* | "Plan Comparison" |
*
* @param {Settings_Plan_ComparisonInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_plan_comparison = /** @type {((inputs?: Settings_Plan_ComparisonInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Plan_ComparisonInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_plan_comparison(inputs)
	if (locale === "fr") return fr_settings_plan_comparison(inputs)
	if (locale === "es") return es_settings_plan_comparison(inputs)
	if (locale === "it") return it_settings_plan_comparison(inputs)
	if (locale === "nl") return nl_settings_plan_comparison(inputs)
	if (locale === "pl") return pl_settings_plan_comparison(inputs)
	if (locale === "fi") return fi_settings_plan_comparison(inputs)
	if (locale === "da") return da_settings_plan_comparison(inputs)
	if (locale === "sv") return sv_settings_plan_comparison(inputs)
	return en_settings_plan_comparison(inputs)
});